// About Le Chic Beauty (pages/about-us.html): live collection facts + SEO
(function () {
  const e = LC.escape;
  const path = LC.pageUrl('about-us');
  const holder = document.getElementById('about-collections');
  const facts = LC.collectionOrder.map((key) => {
    const col = LC.collections[key];
    return { key, col };
  });
  if (holder) {
    holder.innerHTML = `<ul>${facts.map((f) => `
      <li><strong><a href="${LC.collectionUrl(f.key)}">${e(f.col.name)}</a></strong>: ${e(f.col.description)}</li>`).join('')}
    </ul>`;
  }

  const title = 'About Le Chic Beauty | Hair Tools, Caviar Hair Care & Remy Extensions';
  const description = 'Le Chic Beauty makes infrared hair styling tools, Repairing Caviar hair care and 100% Remy human hair extensions, with a Limited Lifetime Warranty on registered tools.';
  LC.seo({
    title,
    description,
    path,
    jsonld: [
      LC.webPageLd('AboutPage', path, title, description, {
        breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` },
        mainEntity: { '@id': `${LC.SITE}#organization` }
      }),
      Object.assign(LC.breadcrumbLd([['Home', 'index.html'], ['About Le Chic Beauty', path]]), { '@id': `${LC.abs(path)}#breadcrumb` })
    ]
  });
})();
